import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { PERMISSIONS } from "../../constants/permissions";

export default function DefaultHomeRedirect() {
  const { user } = useAuth();
  const permissions = user?.permissions || [];

  if (user?.isAdmin || permissions.includes(PERMISSIONS.PROJECT_VIEW_ALL)) {
    return <Navigate to="/dashboard" replace />;
  }
  if (
    permissions.includes(PERMISSIONS.PROJECT_VIEW_ASSIGNED) ||
    permissions.includes(PERMISSIONS.PROJECT_ASSIGN_USERS)
  ) {
    return <Navigate to="/projects" replace />;
  }
  if (permissions.includes(PERMISSIONS.WORKFLOW_MANAGE_VIEW)) {
    return <Navigate to="/admin/workflows" replace />;
  }
  if (user?.isAdmin) {
    return <Navigate to="/admin/users" replace />;
  }
  return <Navigate to="/projects" replace />;
}
